import {
  Award,
  Building2,
  // CalendarDays,
  ChartColumn,
  // ClipboardCheck,
  // Clock,
  Filter,
  Gauge,
  // GraduationCap,
  // Handshake,
  // MessageSquare,
  // Network,
  // Table2,
  // UserRound,
  // Wallet,
  // Workflow,
} from "lucide-react";
import * as Icons from "@/assets/features/sidebar";

const thin = (Icon) => {
  const ThinIcon = (props) => <Icon strokeWidth={1.5} {...props} />;
  ThinIcon.displayName = `Thin${Icon.displayName ?? "Icon"}`;
  return ThinIcon;
};

const I = {
  // assessments: thin(ClipboardCheck),
  // offers: thin(Handshake),
  // employees: thin(UserRound),
  // learning: thin(GraduationCap),
  // orgChart: thin(Network),
  // orgTable: thin(Table2),
  branches: thin(Building2),
  recruitmentAnalytics: thin(Filter),
  hiringAnalytics: thin(ChartColumn),
  // requisitionAnalytics: thin(Clock),
  qualityOfHire: thin(Award),
  performance: thin(Gauge),
  // workforcePlanning: thin(Workflow),
  // budget: thin(Wallet),
  // calendar: thin(CalendarDays),
  // conversations: thin(MessageSquare),
  company: thin(Building2),
};

// Items commented "404" are v1 menu entries whose pages are not ported to v2
// yet — uncomment each one (and its icon above) once its route exists.
export function createSidebarItems(t, { isAgency = false } = {}) {
  const m = (key) => t(`sidebar.menu.${key}`);
  const section = (key, children) => ({ label: m(`sections.${key}`), children });

  return [
    section("dashboards", [
      { label: m("dashboards"), path: "/dashboard", icon: Icons.Dashboard },
    ]),

    section("recruitment", [
      { label: m("requisitionsManagement"), path: "/job-requisition", icon: Icons.Requisition },
      { label: m("jobRequests"), path: "/job-requests", icon: Icons.JobRequets },
      { label: m("positions"), path: "/positions", icon: Icons.Positions },
      {
        label: m("candidates"),
        icon: Icons.Candidates,
        path: "/candidates-managment",
      },
      // { label: m("assessments"), path: "/assessments", icon: I.assessments },
      // { label: m("evaluations"), path: "/evaluation-forms", icon: Icons.EvaluationForms },
      // { label: m("offers"), path: "/offers", icon: I.offers },
    ]),

    
    // section("people", [
    //   { label: m("employees"), path: "/employees", icon: I.employees },
    //   {
    //     label: m("learning"),
    //     icon: I.learning,
    //     subitems: [
    //       { label: m("trainingHub"), path: "/training-hub" },
    //       { label: m("myLearning"), path: "/my-learning" },
    //     ],
    //   },
    // ]),

    section("organization", [
      
      // { label: m("organizationChart"), path: "/workforce-structure/chart", icon: I.orgChart },
      // { label: m("organizationTable"), path: "/workforce-structure/table", icon: I.orgTable },
      { label: m("branches"), path: "/branches", icon: I.branches },
      ...(isAgency
        ? [{ label: m("clientsBoard"), path: "/clients-board", icon: Icons.ClientBoard }]
        : []),
    ]),

    section("analytics", [
      {
        label: m("recruitmentAnalytics"),
        icon: I.recruitmentAnalytics,
        subitems: [
          { label: m("sourcing"), path: "/reports/sourcing-charts" },
          { label: t("sidebar.reportsCandidatePipelineFlow"), path: "/reports/candidate-pipeline-flow" },
          { label: t("sidebar.reportsBlacklistedCandidate"), path: "/reports/blacklisted-candidate-report" },
        ],
      },
      {
        label: m("hiringAnalytics"),
        icon: I.hiringAnalytics,
        subitems: [
          { label: m("positionCharts"), path: "/reports/position-charts" },
          { label: m("candidateCharts"), path: "/reports/candidate-charts" },
          { label: m("applicationCharts"), path: "/reports/application-charts" },
          { label: m("interviewCharts"), path: "/reports/interview-analytics" },
          { label: m("requisitionCharts"), path: "/reports/requisition-charts" },
          
          // ...(isAgency ? [{ label: m("agencyCharts"), path: "/clients-reports" }] : []),
        ],
      },
      
      // {
      //   label: m("requisitionAnalytics"),
      //   icon: I.requisitionAnalytics,
      //   subitems: [{ label: m("requisitionAging"), path: "/reports/requisition-aging" }],
      // },
      {
        label: m("qualityOfHire"),
        icon: I.qualityOfHire,
        subitems: [
          
          // { label: m("interviewToHire"), path: "/reports/interview-to-hire" },
          // { label: m("costPerHire"), path: "/reports/cost-per-hire" },
          // { label: m("timeToFill"), path: "/reports/time-to-fill" },
          // { label: m("timeToHire"), path: "/reports/time-to-hire" },
          { label: t("sidebar.reportsEvaluation"), path: "/reports/evaluation-report" },
        ],
      },
      {
        label: m("performanceReports"),
        icon: I.performance,
        subitems: [
          { label: t("sidebar.reportsPerformanceAnalytics"), path: "/reports/performance-analytics" },
          
          // { label: m("hiringManagerPerformance"), path: "/reports/hiring-manager-performance" },
          // { label: m("recruiterPerformance"), path: "/reports/recruiter-performance" },
          // { label: m("vacancyRate"), path: "/reports/vacancy-rate" },
          // { label: m("offerAcceptance"), path: "/reports/offer-acceptance-rate" },
          // { label: m("rejectionReasons"), path: "/reports/rejection-reasons" },
        ],
      },
    ]),

    
    // section("planning", [
    //   {
    //     label: m("workforcePlanning"),
    //     icon: I.workforcePlanning,
    //     subitems: [{ label: m("workforceCalculator"), path: "/workforce-structure/calculator" }],
    //   },
    //   { label: m("budgetPlanning"), path: "/budget-configuration", icon: I.budget },
    // ]),

    
    // section("tools", [
    //   {
    //     label: m("calendar"),
    //     icon: I.calendar,
    //     subitems: [
    //       { label: m("scheduling"), path: "/interview-schedule" },
    //       { label: m("personalCalendar"), path: "/personal-calendar" },
    //     ],
    //   },
    //   { label: m("conversations"), path: "/conversations", icon: I.conversations },
    // ]),

    section("settings", [
      {
        label: m("company"),
        icon: I.company,
        subitems: [
          
          // { label: m("companyProfile"), path: "/profile" },
          { label: m("configuration"), path: "/settings/configuration" },
        ],
      },
      {
        label: m("formsAndTemplates"),
        icon: Icons.FormsTemplates,
        subitems: [
          
          // { label: m("templates"), path: "/system-defaults/templates" },
          // { label: m("referenceForms"), path: "/system-defaults/reference-form-generation" },
          { label: m("listsAndOptions"), path: "/forms-templates/lists-options" },
        ],
      },
      {
        label: m("hiringDefaults"),
        icon: Icons.Settings,
        subitems: [
          { label: m("generalDefaults"), path: "/settings/defaults" },
          
          // { label: m("budgets"), path: "/budget-configuration" },
          // { label: m("scoring"), path: "/system-defaults/score-configuration" },
        ],
      },
      
      // { label: m("dataManagement"), path: "/data-managment", icon: Icons.DataManagment },
    ]),
  ].filter((group) => group.children.length > 0);
}
